import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "budgets",
    name: "Targets & budgets",
    version: "0.1.0",
    tier: "addon",
    accent: "cash",
    dependsOn: ["sites"],
    description: "Head office sets targets per site with a wizard (core shop, departments, concessions, fuel litres by grade, waste, wages, anything) and everyone sees how their sites are tracking.",
    permissions: {
        view: "See budgets and progress for your sites",
        manage: "Create, change and publish targets (head office)",
    },
    grants: {
        "Head office": ["view", "manage"],
        "Area manager": ["view"],
        "Site manager": ["view"],
        Supervisor: ["view"],
    },
    widgets: [
        { key: "targets", title: "Against target", description: "Shop sales against this period's targets, site by site.", group: "Sales", size: 2, permission: "view", defaultOn: true, order: 15 },
    ],
    nav: [
        { label: "Targets", path: "/budgets", section: "dashboard", tab: "Targets", tabIcon: "target", permission: "view", icon: "target", order: 60, blurb: "Targets for every site and how each one is tracking" },
    ],
    // The set-up tool's question (29/10/26), written into the Financial year step when it hasn't been answered.
    questions: [
        {
            id: "year", ask: "When does your financial year start?", help: "Targets run over your financial year.",
            options: [
                { value: "04-01", label: "1 April" },
                { value: "04-06", label: "6 April" },
                { value: "01-01", label: "1 January" },
                { value: "other", label: "Another day", help: "Choose it in Set-up → Targets → Financial year." },
            ],
        },
    ],
    setup: [
        {
            id: "financial-year",
            title: "Financial year",
            scope: "tenant",
            why: "Budgets run over your financial year, so the wizard starts in the right month. Give the day too (e.g. 6 April).",
            blocking: false,
            fields: [
                {
                    key: "start_day", label: "On day", type: "select",
                    options: Array.from({ length: 31 }, (_, i) => ({ value: String(i + 1), label: String(i + 1) })),
                    help: "The day of the month it starts (1 if it starts on the 1st).",
                },
                {
                    key: "start_month", label: "Your financial year starts in", type: "select", required: true,
                    options: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                        .map((m, i) => ({ value: String(i + 1), label: m })),
                },
            ],
        },
    ],
});
